import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

/**
 * Footer component
 */
const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {/* Left side - Copyright and links */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              © {currentYear} MaatriSahayak. All rights reserved.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
              <Link
                href="/privacy"
                color="text.secondary"
                variant="body2"
                sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms"
                color="text.secondary"
                variant="body2"
                sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              >
                Terms of Service
              </Link>
              <Link
                href="/contact"
                color="text.secondary"
                variant="body2"
                sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              >
                Contact
              </Link>
            </Box>
          </Box>

          {/* Center - App info */}
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: 'primary.main',
                mb: 0.5,
                fontSize: '1.1rem',
              }}
            >
              MaatriSahayak
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Maternal Health Emergency Response Platform
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
              Version 1.0.0
            </Typography>
          </Box>
        </Box>

        {/* Bottom section */}
        <Box
          sx={{
            mt: 3,
            pt: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
            textAlign: 'center',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            This platform is designed for District Health Officers to monitor and manage maternal health emergencies.
            For emergency assistance, please contact your local health authorities.
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
            System Status: <Box component="span" sx={{ color: 'success.main', fontWeight: 600 }}>● Operational</Box>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;